import { mapGetters } from "vuex";
import { ErrorLogService, VisrService } from "@/services";

export default {
  name: "VisrTermsForm",
  data() {
    return {
      termsHtml: "",
      isLoading: true,
      loadFailed: false,
      isDownloading: false,
      hasScrolledToBottom: false,
      isAgreed: false,
      // Opens automatically the first time a VIS part is detected
      isModalOpen: true,
      isModalShown: false
    };
  },
  computed: {
    ...mapGetters(["getContentItem"]),

    termsVisible() {
      return !this.isLoading && !this.loadFailed;
    },

    // Once agreed, the user has necessarily read to the end, so reopening keeps the checkbox visible
    showAgreeCheckbox() {
      return this.termsVisible && (this.hasScrolledToBottom || this.isAgreed);
    },

    showScrollPrompt() {
      return this.termsVisible && !this.showAgreeCheckbox;
    }
  },
  created() {
    // Agreement always starts unchecked, including when the form is shown again
    this.emitAgreementState();
    this.loadTerms();
  },
  beforeDestroy() {
    this.$emit("agreement-changed", false);
  },
  methods: {
    async loadTerms() {
      this.isLoading = true;
      this.loadFailed = false;

      try {
        const terms = await VisrService.GetTerms();
        this.termsHtml = terms.Html;
      } catch {
        this.loadFailed = true;
      } finally {
        this.isLoading = false;
      }

      if (!this.loadFailed) {
        this.$nextTick(this.revealIfNoScrollNeeded);
      }
    },

    // Without a scrollbar no scroll event fires, so the checkbox would never appear
    revealIfNoScrollNeeded() {
      const box = this.$refs.termsBox;

      // A hidden modal measures 0 height, which must not count as "nothing to scroll"
      if (!this.isModalShown || !box || box.clientHeight === 0) {
        return;
      }

      if (box.scrollHeight <= box.clientHeight) {
        this.hasScrolledToBottom = true;
      }
    },

    openModal() {
      this.isModalOpen = true;
    },

    onModalShown() {
      this.isModalShown = true;
      this.revealIfNoScrollNeeded();
    },

    // Safety net: the modal must not close until the terms are agreed
    onModalHide(event) {
      if (!this.isAgreed) {
        event.preventDefault();
        return;
      }

      this.isModalShown = false;
    },

    onTermsScroll(event) {
      if (this.hasScrolledToBottom) {
        return;
      }

      const el = event.target;
      const scrolledToBottom = el.scrollHeight - el.scrollTop - el.clientHeight <= 2;

      if (scrolledToBottom) {
        this.hasScrolledToBottom = true;
      }
    },

    onAgreedChanged() {
      this.emitAgreementState();
    },

    emitAgreementState() {
      this.$emit("agreement-changed", this.isAgreed === true);
    },

    async downloadTerms() {
      this.isDownloading = true;

      try {
        await VisrService.DownloadTerms();
      } catch (err) {
        this.$store.commit("pushTimedMessage", {
          header: ErrorLogService.LogAndGetErrorMessage(err),
          IsError: true,
          seconds: 15,
        });
      } finally {
        this.isDownloading = false;
      }
    }
  }
};
